import React, { Suspense } from "react";
import IconWrap, { IconWrapProps } from "./IconWrap/IconWrap";
import iconPathRegistry from "./config/iconPathRegistry";

export type Icons = keyof typeof iconPathRegistry;

interface Props extends Omit<IconWrapProps, "children"> {
    icon: Icons;
}

const Icon = ({ ...props }: Props) => {
    const IconToRender = iconPathRegistry[props.icon];

    return (
        <Suspense>
            <IconWrap {...props}>
                <IconToRender />
            </IconWrap>
        </Suspense>
    );
};

export default Icon;
